/* Blanks Broker — Quick-order grid.
 * Predictive search → SKU autocomplete → cart batch-add.
 */
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function moneyFormat(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  customElements.define('bb-quick-order', class extends HTMLElement {
    connectedCallback() {
      try { this.routes = JSON.parse(this.getAttribute('data-routes') || '{}'); } catch (e) { this.routes = {}; }
      this.rowsEl = this.querySelector('[data-bb-rows]');
      this.subtotalEl = this.querySelector('[data-bb-subtotal]');
      this.errorEl = this.querySelector('[data-bb-error]');
      this.template = this.parentNode.querySelector('#bb-quick-order-row-template');

      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
    }

    onInput(e) {
      var t = e.target;
      if (t.matches('[data-bb-sku]'))     this.handleSkuInput(t);
      else if (t.matches('[data-bb-qty]')) this.recalcRow(t.closest('[data-bb-row]'));
    }

    onClick(e) {
      var t = e.target;
      if (t.matches('[data-bb-remove]')) {
        var row = t.closest('[data-bb-row]');
        if (this.querySelectorAll('[data-bb-row]').length > 1) row.remove();
        else this.resetRow(row);
        this.recalcSubtotal();
      } else if (t.matches('[data-bb-add-row]')) {
        this.addRow();
      } else if (t.matches('[data-bb-submit]')) {
        this.submitToCart();
      } else if (t.matches('[data-bb-suggestion]')) {
        var row = t.closest('[data-bb-row]');
        this.applySuggestion(row, t);
      }
    }

    addRow() {
      if (!this.template) return;
      var frag = this.template.content.cloneNode(true);
      this.rowsEl.appendChild(frag);
    }

    resetRow(row) {
      row.querySelector('[data-bb-sku]').value = '';
      row.querySelector('[data-bb-qty]').value = '0';
      row.querySelector('[data-bb-variant]').textContent = '—';
      row.querySelector('[data-bb-variant-id]').value = '';
      row.querySelector('[data-bb-unit-price]').value = '0';
      row.querySelector('[data-bb-line-total]').textContent = moneyFormat(0);
      var sg = row.querySelector('[data-bb-suggestions]');
      if (sg) sg.remove();
    }

    handleSkuInput(input) {
      var row = input.closest('[data-bb-row]');
      var q = (input.value || '').trim();
      if (!q) {
        var sg = row.querySelector('[data-bb-suggestions]');
        if (sg) sg.remove();
        return;
      }
      this._predict = this._predict || debounce(this.predictiveSearch.bind(this), 200);
      this._predict(row, q);
    }

    predictiveSearch(row, query) {
      var url = (this.routes.predict || '/search/suggest.json') +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6&resources[options][unavailable_products]=last';
      var self = this;
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          self.renderSuggestions(row, products);
        })
        .catch(function () { /* swallow — UI stays unchanged */ });
    }

    renderSuggestions(row, products) {
      var existing = row.querySelector('[data-bb-suggestions]');
      if (existing) existing.remove();
      if (!products.length) return;

      var list = document.createElement('div');
      list.setAttribute('data-bb-suggestions', '');
      list.style.cssText = 'grid-column: 1 / -1; background: var(--bb-paper); border: 1px solid var(--bb-line); border-radius: var(--bb-radius-sm); padding: 4px; margin-top: 6px; display: flex; flex-direction: column; gap: 2px;';

      products.forEach(function (p) {
        if (!p.variants) return;
        p.variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('data-bb-suggestion', '');
          btn.setAttribute('data-bb-vid', v.id);
          btn.setAttribute('data-bb-vprice', v.price);
          btn.setAttribute('data-bb-vsku', v.sku || '');
          btn.setAttribute('data-bb-vtitle', v.title);
          btn.setAttribute('data-bb-ptitle', p.title);
          btn.style.cssText = 'text-align: left; padding: 8px 10px; background: transparent; border: 0; cursor: pointer; font-family: var(--bb-font-body); border-radius: var(--bb-radius-sm);';
          var nameEl = document.createElement('strong');
          nameEl.textContent = p.title || '';
          var metaEl = document.createElement('span');
          metaEl.className = 'bb-mono';
          metaEl.style.cssText = 'color: var(--bb-ink-3); margin-left: 8px;';
          metaEl.textContent = (v.sku || '') + ' · ' + (v.title || '');
          var priceEl = document.createElement('span');
          priceEl.style.cssText = 'float: right;';
          priceEl.textContent = moneyFormat(v.price);
          btn.appendChild(nameEl);
          btn.appendChild(metaEl);
          btn.appendChild(priceEl);
          btn.addEventListener('mouseover', function () { btn.style.background = 'var(--bb-paper-alt)'; });
          btn.addEventListener('mouseout',  function () { btn.style.background = 'transparent'; });
          list.appendChild(btn);
        });
      });

      row.appendChild(list);
    }

    applySuggestion(row, btn) {
      var vid    = btn.getAttribute('data-bb-vid');
      var vprice = btn.getAttribute('data-bb-vprice');
      var vsku   = btn.getAttribute('data-bb-vsku');
      var ptitle = btn.getAttribute('data-bb-ptitle');
      var vtitle = btn.getAttribute('data-bb-vtitle');

      row.querySelector('[data-bb-sku]').value = vsku || ptitle;
      row.querySelector('[data-bb-variant-id]').value = vid;
      row.querySelector('[data-bb-unit-price]').value = vprice;
      row.querySelector('[data-bb-variant]').textContent = vtitle;

      var qtyEl = row.querySelector('[data-bb-qty]');
      if (parseInt(qtyEl.value, 10) === 0) qtyEl.value = '1';

      var sg = row.querySelector('[data-bb-suggestions]');
      if (sg) sg.remove();
      this.recalcRow(row);
    }

    recalcRow(row) {
      var unit = parseFloat(row.querySelector('[data-bb-unit-price]').value) || 0;
      var qty  = parseInt(row.querySelector('[data-bb-qty]').value, 10) || 0;
      row.querySelector('[data-bb-line-total]').textContent = moneyFormat(unit * qty);
      this.recalcSubtotal();
    }

    recalcSubtotal() {
      var rows = this.querySelectorAll('[data-bb-row]');
      var sum = 0;
      rows.forEach(function (row) {
        var unit = parseFloat(row.querySelector('[data-bb-unit-price]').value) || 0;
        var qty  = parseInt(row.querySelector('[data-bb-qty]').value, 10) || 0;
        sum += unit * qty;
      });
      this.subtotalEl.textContent = moneyFormat(sum);
    }

    submitToCart() {
      var rows = this.querySelectorAll('[data-bb-row]');
      var items = [];
      rows.forEach(function (row) {
        var vid = row.querySelector('[data-bb-variant-id]').value;
        var qty = parseInt(row.querySelector('[data-bb-qty]').value, 10) || 0;
        if (vid && qty > 0) items.push({ id: parseInt(vid, 10), quantity: qty });
      });

      this.errorEl.hidden = true;
      this.errorEl.textContent = '';

      if (!items.length) {
        this.errorEl.hidden = false;
        this.errorEl.textContent = 'Add at least one SKU with a quantity ≥ 1 before submitting.';
        return;
      }

      var url = (this.routes.add || '/cart/add.js');
      var self = this;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Add to cart failed.'); });
          return r.json();
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          self.errorEl.hidden = false;
          self.errorEl.textContent = err.message || String(err);
        });
    }
  });
})();
